<template>
    <!-- 分析内容 -->
    <div >
        <div class="analysis-info" v-loading="loading">
            <el-row type="flex" class="row-bg info-top" justify="space-between">
                <el-col :span='5' class="top-btn">
                    <el-button  type="primary" size="small" @click="save_result" :loading='isDerive'>保存结果</el-button>
                     <el-button  type="primary" size="small" @click="report" >生成报告</el-button>
                </el-col>
                <el-col :span="9" class="top-search">
                    <div>{{searchLabel}}
                        <el-input type='number' :min=1 class="search-value" size="mini" v-model="reqData.pRight"></el-input> 
                    </div>
                    <div>频次：
                        <el-input type='number' :min=1 class="search-value" size="mini" v-model="reqData.pinCi"></el-input> 
                    </div>
                    <el-button  type="primary" size="small" @click="getList()">筛选</el-button>
                </el-col>
                <el-col :span="10">
                    <div class="top-tip">由于数据量较大，请将数据筛选后进行保存或生成报告。</div>
                </el-col>
            </el-row>
            <el-table
                :header-cell-style="{background:'#a7754f',color:'#fff'}"
                size='mini'
                :data="tableList"
                row-key="id"
                border
                @sort-change="sort_change"
                default-expand-all>
                <el-table-column
                    :label="reqData.leftTitle"
                    sortable
                    :prop="analysisType=='mutual'?'afterItem':'elementOne'"
                ></el-table-column>
                <el-table-column
                    :label="reqData.rightTitle"
                    sortable
                    :prop="analysisType=='mutual'?'beforeItem':'elementTwo'" 
                >
                </el-table-column>
                <!--  卡方 -->
                <el-table-column
                    v-if='analysisType=="check"'
                    align="center"
                    prop="commonNum"
                    sortable
                    label= '频次'> 
                </el-table-column>
                <el-table-column
                    v-if='analysisType=="check"'
                    align="center"
                    prop="pvalue"
                    sortable
                    label= 'P值'>
                    <template slot-scope="scope">
                        <span :class="scope.row.pvalue<0.05?'top-tip':'' ">{{scope.row.pvalue}}</span>
                    </template> 
                </el-table-column>
                <!-- 贝叶斯 -->
                <el-table-column
                    v-if='analysisType=="bayes"'
                    align="center"
                    prop="probability"
                    sortable
                    label= '概率'>
                </el-table-column>
                <el-table-column
                    v-if='analysisType=="bayes"'
                    align="center"
                    prop="viewTime"
                    sortable
                    label= '频次'>
                </el-table-column>
                <!-- 互信息 -->
                <el-table-column
                    v-if='analysisType=="mutual"'
                    align="center"
                    prop="matchCount"
                    sortable
                    label= '同现频次'>
                </el-table-column>
                <el-table-column
                    v-if='analysisType=="mutual"'
                    align="center"
                    prop="probabilityOfPoint"
                    sortable
                    label= '点式互信息'>
                </el-table-column>
            </el-table>
            <el-pagination 
                size='small'
                class="page-wrap"  
                @current-change="changePage" 
                @size-change="sizeChange"
                background
                :current-page="pageInfo.pageNum" 
                :page-count="pageInfo.pageTotal" 
                :page-size="pageInfo.pageSize"
                :page-sizes="[10, 20, 30, 50, 100]"
                :total="pageInfo.total"
                layout="total, sizes, prev, pager, next, jumper" >
            </el-pagination>
        </div>
         <!-- 生成报告 三个单独接口，所以不用reportModel-->
        <modelTip :ok="'确定'" :cancel="'取消'" :show.sync='isShowReport' @ok='report_sure' :save='isReport' :width="'450px'" :title="'生成报告'">
            <div slot="content" >
                <el-form class="form-data">
                    <el-form-item label="文件名称："  label-width="90px">
                        <el-input v-model="reportName"></el-input>
                    </el-form-item>
                </el-form>
                 
            </div>
        </modelTip>

        <!-- <reportModel  :ok="'确定'" :cancel="'取消'" :show.sync='isShowReport' :titleName='titleName' :reportList='tableList' ></reportModel> -->
    </div>
</template>

<script>

import modelTip from "../../../components/ui-kit/model_tip.vue"
import reportModel from '../comps/report_model.vue'
import {algorithm_chiSquare,algorithm_bayes,mutualInformation,
        exportBayes,exportChiSquare,exportMutualInformation,
        chiSquareCreateExport,bayesCreateExport,mutualInformationCreateExport} from '../../../io/api.js'
export default {
    props: ['beforeValue','afterValue','analysisType'],
    components: {
        modelTip,
        reportModel,
    },
    data () {
        return {
            reqData:{
                pRight:'',
                pinCi:'',
                leftTitle:'',
                rightTitle:'',
            },
            
            titleName:'',
            titleLabel:'',//生成报告的后缀
            searchLabel:'',
            isShowReport:false,
            loading:false,
            reportName:'',
            tableList:[],
            tableListAll:[],
            pageInfo: {
                pageNum: 1,
                pageTotal: 1,
                total: 1,
                pageSize: 10,
            },
            isDerive:false,
            isReport:false,
        }
    },
    mounted () {
        
        if(this.analysisType=='check'){
            this.titleLabel=`-卡方检验`
            this.searchLabel='P值<'
        } else if(this.analysisType=='bayes'){
            this.titleLabel=`-贝叶斯`
            this.searchLabel='概率：'
        }else if(this.analysisType=='mutual'){
            this.titleLabel=`-互信息法`
            this.searchLabel='互信息：'
        } 

    },
    methods: {
        //父级页面查询
        filtrate_result(){
            this.pageInfo.pageNum=1;
            this.reqData.pRight='',//P值
            this.reqData.pinCi='',
            this.getList();
        },
        //查询数据
        getList(){
            this.titleName=`${(this.beforeValue?this.beforeValue:"")}-${(this.afterValue?this.afterValue:"")}${this.titleLabel}`;
            this.reqData.leftTitle=this.beforeValue;
            this.reqData.rightTitle=this.afterValue;
            this.loading=true;
            let params = {
                pageNum:this.pageInfo.pageNum,
                pageSize:this.pageInfo.pageSize,
                // leftTitle:this.beforeValue,//左侧标题
                // rightTitle:this.afterValue,//右侧标题
                 ...this.reqData
            }
            if(this.analysisType=='check'){
                this.chiSquare(params);
            } else if(this.analysisType=='bayes'){
                this.getBayes(params)
            }else if(this.analysisType=='mutual'){
                this.getMutual(params)
            }
        },
        chiSquare(params){
            algorithm_chiSquare(params).then(res=>{
                let data = res.data; 
                if(data&&data.code==0){
                    this.setTableData(data.data) 
                }else{
                    this.$message.error(data.msg||'请求失败～')
                }
                this.loading=false;
            })
        },
        getBayes(params){
            algorithm_bayes(params).then(res=>{
                let data = res.data;
                if(data&&data.code==0){
                    this.setTableData(data.data)
                   
                }else{
                    this.$message.error(data.msg||'请求失败～')
                }
                this.loading=false
            })
        },
        getMutual(params){
            mutualInformation(params).then(res=>{
                let data = res.data;
                if(data&&data.code==0){
                    this.setTableData(data.data)
                    // this.changePage(1)
                }else{
                    this.$message.error(data.msg||'请求失败～')
                }
                this.loading=false;
            })
        },
        setTableData(data){
            this.isShowInfo = true;
            this.tableList=data.list||[]; 
            this.pageInfo.pageTotal=data.totalPage;
            this.pageInfo.total=data.totalNum;
            this.pageInfo.pageSize=data.pageSize;
            this.reqData.pRight='';
            this.reqData.pinCi=''; 
        },
        //保存结果
        save_result(){
 
            let params =this.reqData;
            this.isDerive=true;
            if(this.analysisType=='check'){ 
                exportBayes(params).then(res=>{
                    {
                        this.down_blob(`${this.titleName}.xls`,res)
                    }
                })
            } else if(this.analysisType=='bayes'){
                exportChiSquare(params).then(res=>{
                    {
                        this.down_blob(`${this.titleName}.xls`,res)
                    }
                })
            }else if(this.analysisType=='mutual'){
                exportMutualInformation(params).then(res=>{
                    {
                        this.down_blob(`${this.titleName}.xls`,res)
                    }
                })
            }
        }, 
        //导出文档流处理
        down_blob(name,res){ 
            let typeCount = {
                type: "application/octet-stream",
            }; 
            let blob = new Blob([res.data],typeCount); 
            let url = window.URL.createObjectURL(blob);
            let link = document.createElement("a");
            link.style.display = "none";
            link.href = url;
            link.setAttribute("download", name);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            this.isDerive = false;
        },
        //生成报告
        report(){ 
            this.isShowReport = true;
        }, 
        report_sure(){
            if(this.reportName==''){
                this.$message.error('请输入文件名称');
                return
            } 
            let params={
                fileName:this.reportName,
                ...this.reqData
            }
            this.isReport = true;
            if(this.analysisType=='check'){ 
                chiSquareCreateExport(params).then(res=>{
                    this.report_success(res)
                })
            } else if(this.analysisType=='bayes'){
                bayesCreateExport(params).then(res=>{
                    this.report_success(res)
                })
            }else if(this.analysisType=='mutual'){
                mutualInformationCreateExport(params).then(res=>{
                    this.report_success(res)
                })
            }
        },
        report_success(res){
            let data = res.data;
            if(data&&data.code==0){
                this.$message({ 
                    message: '生成报告成功',
                    type: 'success'
                });
                this.handleClose()
            }else{
                this.$message.error(data.msg||'请求失败～');
            }
            this.isReport = false;
        },
        //关闭生成报告弹层
        handleClose(){
            this.isShowReport = false;
            this.reportName='';
        },
        // 分页
        changePage(num) { 
            this.pageInfo.pageNum = num;    
            this.getList();      
           
        }, 
        sizeChange(val){
            this.pageInfo.pageTotal=Math.ceil(this.pageInfo.total/val),
            this.pageInfo.pageSize=val; 
            this.changePage(1)
        },
        sort_change(column) { // column是个形参，具体查看element-ui文档
            //this.column = column;
            // this.pageInfo.total = this.tableListAll.length
            // this.tableList = this.tableListAll.sort(this.sortFun(column.prop, column.order === 'ascending'));
            // 回到第一页
            // this.changePage(1);

        },
        sortFun (attr, rev) {
            //第一个参数传入info里的prop表示排的是哪一列，第二个参数是升还是降排序
            if (rev == undefined) {
                rev = 1;
            } else {
                rev = (rev) ? 1 : -1;
            }
            return function (a, b) {
                a = a[attr];
                b = b[attr];
                if (a < b) {
                    return rev * -1;
                }
                if (a > b) {
                    return rev * 1;
                }
                return 0;
            }
        },
       
    }
}
</script>

<style lang="less" scoped>
.analysis-info/deep/.el-table .cell{ 
    line-height: 32px;
}
</style>